import React from "react";
import Banner from "../../../Components/Common/Banner";
import process_banner_image from "../../../Assets/images/BannerImages/Process.png";
import GetInTouchUs from "../../../Components/Common/GetInTouchUs";
import register_img from "../../../Assets/images/Process/register_img.png";
import Enrollment from "../../../Assets/images/Process/Enrollment.png";
import Evaluation from "../../../Assets/images/Process/Evaluation.png";
import Evaluation2 from "../../../Assets/images/Process/Evaluation2.png";
import Career from "../../../Assets/images/Process/Career.png";
import Resume from "../../../Assets/images/Process/Resume.png";
import arrow_right from "../../../Assets/images/Process/arrow_right.png";
import arrow_left from "../../../Assets/images/Process/arrow_left.png";
import TechnicalMockInterviews from "../../../Assets/images/Process/TechnicalMockInterviews.png";
import grooming from "../../../Assets/images/Process/Grooming.png";
import jobSearch from "../../../Assets/images/Process/JobSearch.png";
import feedback from "../../../Assets/images/Process/feedback.png";
import Onboarding from "../../../Assets/images/Process/Onboarding.png";
import quotation from "../../../Assets/images/Process/quotation.png";

const Process = () => {
  return (
    <div>
      <Banner
        pageName="Process"
        bgimage={process_banner_image}
        breadcrummbs={`Home / Knowledge / Process`}
      />
      <div className="lg:px-20 md:px-10 px-5   py-10 tracking-wide">
        <h1 className="text-center text-2xl font-bold lg:w-[80%]  m-auto">
          How Our
          <b className="text-primaryOrangeColor">Process</b> Works at TechMentee
        </h1>
        <p className="text-secondaryTextColor mt-4 text-center m-auto lg:w-[70%] tracking-wide">
          At TechMentee, we are committed to empowering individuals to thrive in
          the tech industry by offering comprehensive programs that cater to
          your career aspirations. Here's how our structured process unfolds:
        </p>
        <div className="py-10 flex flex-col lg:gap-0 gap-10">
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
            <div className="flex lg:justify-start justify-center">
              <img src={register_img} alt="register_img" />
            </div>
            <div className="flex items-center">
              <div>
                <h1 className="font-bold text-xl">Register</h1>
                <p className="tracking-wide mt-2 text-justify">
                  Begin your journey by signing up for the program that aligns
                  with your career aspirations. This involves selecting from a
                  range of courses and services offered to match your goals.
                  During registration, you'll provide essential personal
                  information and complete the enrollment by purchasing your
                  chosen program.
                </p>
                <img
                  src={arrow_right}
                  alt="arrow right img"
                  className="absolute xl:w-[250px] lg:w-[180px] ml-[-120px] mt-[100px] lg:flex hidden"
                />
              </div>
            </div>
          </div>

          <div className="lg:grid lg:grid-cols-2 flex flex-col-reverse">
            <div className="flex items-center">
              <div>
                <h1 className="font-bold text-xl">Enrollment</h1>
                <p className="tracking-wide mt-2 text-justify">
                  Following your purchase, there will be an enrollment process
                  to validate your purchase and electronically sign the
                  Enrollment Form. This document details our general terms and
                  conditions, deliverables, refund policy, and service delivery
                  policy. Our HR team will guide you through each step of the
                  enrollment process.
                </p>
                <img
                  src={arrow_left}
                  alt="arrow right img"
                  className="absolute xl:ml-[35%] lg:ml-[40%] mt-[80px] xl:w-[250px] lg:w-[180px] lg:flex hidden"
                />
              </div>
            </div>
            <div className="flex justify-end">
              <img src={Enrollment} alt="register_img" />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
            <div className="flex lg:justify-start justify-center">
              <img src={Evaluation} alt="Evaluation" />
            </div>
            <div className="flex items-center">
              <div>
                <h1 className="font-bold text-xl">Evaluation & Gap Analysis</h1>
                <p className="tracking-wide mt-2 text-justify">
                  After Enrollment, you'll undergo a comprehensive evaluation
                  aimed at assessing your current skill set and career
                  objectives. This evaluation helps pinpoint areas where
                  additional training or development may be beneficial.
                  Identifying these gaps early allows us to tailor the program
                  specifically to your career goals and program objectives.
                </p>
                <img
                  src={arrow_right}
                  alt="arrow right img"
                  className="absolute xl:w-[250px] lg:w-[180px] ml-[-120px] mt-[100px] lg:flex hidden"
                />
              </div>
            </div>
          </div>

          <div className="lg:grid lg:grid-cols-2 flex flex-col-reverse">
            <div className="flex items-center">
              <div>
                <h1 className="font-bold text-xl">
                  Career Enablement Training
                </h1>
                <p className="tracking-wide mt-2 text-justify">
                  Specific program codes that include Career Enablement
                  Training, once your strengths and development areas are
                  identified, you'll embark on a thorough training journey
                  designed to enhance your technical skills. Whether focusing on
                  IT or other covered domains, the curriculum offers practical,
                  hands-on learning experiences.
                </p>
                <img
                  src={arrow_left}
                  alt="arrow right img"
                  className="absolute xl:ml-[35%] lg:ml-[40%] mt-[80px] xl:w-[250px] lg:w-[180px] lg:flex hidden"
                />
              </div>
            </div>
            <div className="flex justify-end">
              <img src={Career} alt="register_img" />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
            <div className="flex lg:justify-start justify-center">
              <img src={Resume} alt="Evaluation" />
            </div>
            <div className="flex items-center">
              <div>
                <h1 className="font-bold text-xl">Resume Enhancement</h1>
                <p className="tracking-wide mt-2 text-justify">
                  Crafting an impressive resume is crucial in today's
                  competitive job market. You'll receive personalized guidance
                  to optimize your resume according to industry standards to
                  make it ATS friendly. This includes effectively highlighting
                  your key skills, achievements, and professional experiences.
                  The goal is to ensure your resume stands out and effectively
                  communicates your qualifications to potential employers.
                </p>
                <img
                  src={arrow_right}
                  alt="arrow right img"
                  className="absolute xl:w-[250px] lg:w-[180px] ml-[-120px] mt-[100px] lg:flex hidden"
                />
              </div>
            </div>
          </div>

          <div className="lg:grid lg:grid-cols-2 flex flex-col-reverse">
            <div className="flex items-center">
              <div>
                <h1 className="font-bold text-xl">Evaluation</h1>
                <p className="tracking-wide mt-2 text-justify">
                  Specific program codes that include Career Enablement
                  Training, once your strengths and development areas are
                  identified, you'll embark on a thorough training journey
                  designed to enhance your technical skills. Whether focusing on
                  IT or other covered domains, the curriculum offers practical,
                  hands-on learning experiences.
                </p>
                <img
                  src={arrow_left}
                  alt="arrow right img"
                  className="absolute xl:ml-[35%] lg:ml-[40%] mt-[80px] xl:w-[250px] lg:w-[180px] lg:flex hidden"
                />
              </div>
            </div>
            <div className="flex justify-end">
              <img src={Evaluation2} alt="register_img" />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
            <div className="flex lg:justify-start justify-center">
              <img src={TechnicalMockInterviews} alt="Evaluation" />
            </div>
            <div className="flex items-center">
              <div>
                <h1 className="font-bold text-xl">Technical Mock Interviews</h1>
                <p className="tracking-wide mt-2 text-justify">
                  Practice makes perfect, especially in technical interviews.
                  Through tailored mock interview sessions, you'll simulate
                  real-world interview scenarios. This process helps build your
                  confidence, refine your interview skills, and receive
                  constructive feedback from experienced industry professionals.
                  The aim is to thoroughly prepare you for actual job
                  interviews, significantly enhancing your chances of success.
                </p>
                <img
                  src={arrow_right}
                  alt="arrow right img"
                  className="absolute xl:w-[250px] lg:w-[180px] ml-[-120px] mt-[100px] lg:flex hidden"
                />
              </div>
            </div>
          </div>

          <div className="lg:grid lg:grid-cols-2 flex flex-col-reverse">
            <div className="flex items-center">
              <div>
                <h1 className="font-bold text-xl">Grooming</h1>
                <p className="tracking-wide mt-2 text-justify">
                  Soft skills are equally crucial for professional success.
                  Grooming sessions focus on enhancing essential skills such as
                  communication, presentation, and interpersonal skills. These
                  sessions polish your overall professional demeanor, ensuring
                  you're well-prepared to navigate diverse workplace
                  environments with confidence.
                </p>
                <img
                  src={arrow_left}
                  alt="arrow right img"
                  className="absolute xl:ml-[35%] lg:ml-[40%] mt-[80px] xl:w-[250px] lg:w-[180px] lg:flex hidden"
                />
              </div>
            </div>
            <div className="flex justify-end">
              <img src={grooming} alt="register_img" />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
            <div className="flex lg:justify-start justify-center">
              <img src={jobSearch} alt="Evaluation" />
            </div>
            <div className="flex items-center">
              <div>
                <h1 className="font-bold text-xl">
                  Job Search and Placement Assistance
                </h1>
                <p className="tracking-wide mt-2 text-justify">
                  Navigate our extensive network of over 4000 host organizations
                  and 500+ direct hiring communities to discover diverse job
                  opportunities across industries. Benefit from personalized
                  support throughout your job application and placement journey,
                  including expert assistance with submissions, interview
                  scheduling, and offer negotiations.
                </p>
                <img
                  src={arrow_right}
                  alt="arrow right img"
                  className="absolute xl:w-[250px] lg:w-[180px] ml-[-120px] mt-[100px] lg:flex hidden"
                />
              </div>
            </div>
          </div>

          <div className="lg:grid lg:grid-cols-2 flex flex-col-reverse">
            <div className="flex items-center">
              <div>
                <h1 className="font-bold text-xl">Feedback Analysis</h1>
                <p className="tracking-wide mt-2 text-justify">
                  Feedback is essential for continuous improvement. After each
                  interview and assessment, you'll receive detailed feedback
                  highlighting your strengths and areas for improvement. This
                  feedback enables you to refine your interview strategies and
                  professional approach, enhancing your overall readiness for
                  future career opportunities.
                </p>
                <img
                  src={arrow_left}
                  alt="arrow right img"
                  className="absolute xl:ml-[35%] lg:ml-[40%] mt-[80px] xl:w-[250px] lg:w-[180px] lg:flex hidden"
                />
              </div>
            </div>
            <div className="flex justify-end">
              <img src={feedback} alt="register_img" />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
            <div className="flex lg:justify-start justify-center">
              <img src={Onboarding} alt="Evaluation" />
            </div>
            <div className="flex items-center">
              <div>
                <h1 className="font-bold text-xl">On-Boarding & Job Support</h1>
                <p className="tracking-wide mt-2 text-justify">
                  Once you secure a job, our support continues during the
                  critical onboarding phase. This assistance ensures a smooth
                  transition into your new role, helping you navigate initial
                  challenges confidently. The goal is to support you
                  comprehensively, setting the stage for a successful and
                  rewarding career journey.
                </p>
              </div>
            </div>
          </div>

          <p className="lg:mt-20  text-center font-playwrite font-bold text-lg text-primaryOrangeColor tracking-wider lg:w-[70%] m-auto">
            Our structured approach at TechMentee is designed to empower you
            with the necessary skills, confidence, and opportunities to achieve
            your career goals effectively in the dynamic tech industry.
          </p>
          <img src={quotation} alt="quotation" className="m-auto w-16 lg:mt-8"/>
        </div>
        <GetInTouchUs />
      </div>
    </div>
  );
};

export default Process;
